import { TabsComponent } from "../components/tabs.component";
class ChampionBeerPage {
    constructor() {
        this.championsbeerContainerId = 'championsbeerContainerId';
        this.animationTime = 300;
        // handlerClickIconBeer () {
        //     console.log("RUN EVENT DISPLAY IMAGES");
        //     const containerTabImgs = document.querySelectorAll('.display-image');
        //     if(containerTabImgs) {
        //         Array.from(containerTabImgs).forEach( itemImg => {
        //             itemImg.addEventListener("click", () => {
        //                 this.eventDisplayImage(itemImg);
        //             })
        //         })
        //     }
        // }
        this.eventDisplayImage = (itemImg) => {
            console.log("IMGS : ", itemImg);
            const srcImg = itemImg === null || itemImg === void 0 ? void 0 : itemImg.getAttribute('data-zoom-image');
            const altImg = (itemImg === null || itemImg === void 0 ? void 0 : itemImg.getAttribute('data-zoom-alt')) || '';
            const titleImg = (itemImg === null || itemImg === void 0 ? void 0 : itemImg.getAttribute('data-zoom-title')) || '';
            this.containerImgZoom.style.transform = "rotateY(90deg)";
            this.containerImgZoom.style.opacity = "0";
            setTimeout(() => {
                this.containerImgZoom.style.opacity = "1";
                this.containerImgZoom.style.transform = "rotateY(0)";
                this.containerImgZoom.src = srcImg;
                this.containerImgZoom.setAttribute('alt', altImg);
                this.containerImgZoom.setAttribute('title', titleImg);
            }, this.animationTime);
        };
        this.displayFirstImageFromTabSelected = () => {
            console.log("RUN CODE ....");
            // reset container image
            this.containerImgZoom.src = '';
            // Load default beer image
            const containerTabSelected = document.querySelector('.tab-contents > div:not(.hidden)');
            const firstContainerTagimg = containerTabSelected === null || containerTabSelected === void 0 ? void 0 : containerTabSelected.querySelector('.display-image');
            firstContainerTagimg && this.eventDisplayImage(firstContainerTagimg);
        };
        console.log("START CHAMPION BEER PAGE ....");
        this.initPageConfig();
    }
    initPageConfig() {
        this.containerImgZoom = document.getElementById('containerImgZoom');
        // First landing carousel
        const tabsContainer = document.getElementById(this.championsbeerContainerId);
        if (tabsContainer) {
            const championsBeerTabs = new TabsComponent(this.championsbeerContainerId, this.displayFirstImageFromTabSelected);
            championsBeerTabs.onInit();
            this.displayFirstImageFromTabSelected();
            // // Event click
            // this.handlerClickIconBeer();
        }
    }
}
window.addEventListener('load', function () {
    new ChampionBeerPage();
});
